import React from 'react';

const footer = (props) => <div className="footer">© 2020 Copyright Haiyan Yang</div>;

export default footer;
